export const OktaConstants = {
	QUERY_PARAMS: ['state', 'code', 'nonce', 'code_verifier', 'signInAppWithOkta']
};
